/**
 * KYC submit error copy. The API already returns
 * { error, message, code } on session reject; the form must show
 * message + code, not only "Unauthorized".
 */

export const KYC_SUBMIT_RELOGIN =
  'Your session expired. Please log out and log back in, then submit KYC again.'

export function kycSubmitApiError(apiResult = {}) {
  const code = apiResult.code != null ? String(apiResult.code) : ''
  const error = apiResult.error != null ? String(apiResult.error) : ''
  const message = apiResult.message != null ? String(apiResult.message) : ''

  if (code === 'INVALID_SESSION' || error === 'Unauthorized') {
    const parts = [KYC_SUBMIT_RELOGIN]
    if (message) parts.push(message)
    if (code) parts.push('(' + code + ')')
    return parts.join(' ')
  }

  const blob = error + ' ' + message
  if (blob.includes('23505') || blob.toLowerCase().includes('duplicate')) {
    if (blob.includes('id_number')) {
      return 'This ID/Passport number is already registered with another account.'
    }
    if (blob.includes('email')) {
      return 'This email address is already registered. Please use a different email address.'
    }
  }

  return message || error || 'Failed to submit KYC'
}